import _ from "lodash";

import firebaseapp from "../firebase.js";

const firestoreDB = firebaseapp.firestore();

export default class StateService {
  static getAllStatesFromFirestore = async () => {
    let snapshot = await firestoreDB.collection("states").get();
    return snapshot.docs.map((doc) => doc.data());
  };

  static getStateByName = (states, stateName) => {
    let state = null;
    stateName = stateName.toLowerCase();
    stateName = stateName.trim();

    state = _.filter(states, (state) => {
      return state[`name_en`].toLowerCase() === stateName;
    });

    return state[0] ? state[0] : null;
  };

  static getStateByCode = (states, stateCode) => {
    let state = null;
    stateCode = stateCode.toLowerCase();
    stateCode = stateCode.trim();

    state = _.filter(states, (state) => {
      return state[`code`].toLowerCase() === stateCode;
    });

    return state[0] ? state[0] : null;
  };
}
